export const unitsRoomsAlbumsWithPhotosSelector = ({
  customReportData: { unitsRoomsAblumsWithPhotos: value = [] },
}: any) => value;
export const customReportClaimsSelector = ({ customReportData: { claims: value = [] } }: any) => value;
export const customReportPropertySelector = ({ customReportData: { property: value = {} } }: any) => value;
export const customReportProjectSelector = ({ customReportData: { project: value = {} } }: any) => value;
export const customReportDataSelector = ({ customReportData: value = {} }: any) => value;
